import React from 'react';

function Home() {
  return (
    <div className="message">
      <div className="text">
        <h1>#Nutscaping,</h1>
        <h2>re-imagined.</h2>
      </div>
    </div>
  );
}

export default Home; 